import React from "react";
import HomeComponent from "../../views/web/home";

export default function HomePage() {
  return <HomeComponent />;
}
